import { lazy, Suspense } from 'react'
import { Outlet, type RouteObject } from 'react-router-dom'
import { FullPageLoader } from '@/components/common/FullPageLoader'
import { ROUTES } from './paths'

/**
 * Routes that render outside the authenticated app shell.
 *
 * They share one pathless layout route so a single `<Suspense>` boundary covers
 * every code-split public page.
 */
const SignInPage = lazy(() => import('@/pages/SignInPage'))
const SignUpPage = lazy(() => import('@/pages/SignUpPage'))
const ForgotPasswordPage = lazy(() => import('@/pages/ForgotPasswordPage'))
const PrivacyPolicyPage = lazy(() => import('@/pages/legal/PrivacyPolicyPage'))
const TermsOfServicePage = lazy(() => import('@/pages/legal/TermsOfServicePage'))
const RolesPermissionsSample = lazy(() => import('@/pages/samples/RolesPermissionsSample'))

export const publicRoutes: RouteObject[] = [
  {
    element: (
      <Suspense fallback={<FullPageLoader label="Loading…" />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      { path: ROUTES.signIn, element: <SignInPage /> },
      { path: ROUTES.signUp, element: <SignUpPage /> },
      { path: ROUTES.forgotPassword, element: <ForgotPasswordPage /> },
      // Legal documents: linked from the auth pages and registered on the Google
      // OAuth consent screen, so they must render without signing in.
      { path: ROUTES.privacy, element: <PrivacyPolicyPage /> },
      { path: ROUTES.terms, element: <TermsOfServicePage /> },
      // Design sample for stakeholder review — no auth so it can be shared.
      { path: ROUTES.rolesPermissionsSample, element: <RolesPermissionsSample /> },
    ],
  },
]
